import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  Dimensions,
  Alert,
} from "react-native";
import FilterBar from "app/components/FilterBar";
import Text from "app/components/Text";
import TextInput from "app/components/TextInput";
import chapterActions from "app/utils/chapterActions";
import momentActions from "app/utils/momentActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import valueHelpers from "app/utils/valueHelpers";
import ftueHelpers from "app/utils/ftueHelpers";
import filterHelpers from "app/utils/filterHelpers";
import {
  styleSheet,
  colors,
  sizes,
  screenRatio,
  WIDTH,
  HEIGHT,
} from "app/utils/styleSheet";

import Chapter from "app/components/Chapter";
import MomentList from "app/components/chapter/MomentList";

import store from "app/redux/store";

import {
  Ionicons,
  Octicons,
  FontAwesome,
  FontAwesome5,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

export default class MomentIndex extends React.Component {
  constructor(props) {
    super(props);
    let { navigation, route } = this.props;
    navigation.setOptions({
      headerRight: () => (
        <TouchableOpacity onPress={navigation.toggleDrawer}>
          <Ionicons
            name="ios-menu"
            size={32}
            color={colors.foreground}
            style={{ marginRight: 20 }}
          />
        </TouchableOpacity>
      ),
    });

    // let id = route?.params?.id;
    // let chapter = route?.params?.chapter || {
    //   title: " ",
    //   start_at: undefined,
    //   end_at: undefined,
    //   moment: [],
    //   values: [],
    // };
    this.state = {
      moments: [],
      loading: false,
    };
  }

  async componentDidMount() {
    this.fetch();
  }

  fetch = async () => {
    // let { chapter, id } = this.state;
    await this.setState({ loading: true });
    let res = await momentActions.index();
    if (res?.success) {
      this.setState({ moments: res.moments });
    }
  };

  render() {
    let { loading, moments } = this.state;

    return (
      <View style={[styles.container]}>
        <StatusBar style="auto" />
        {/*<Chapter chapter={chapter} expanded />*/}
        {/*<View />*/}
        <ScrollView
          style={styles.contentWrapper}
          contentContainerStyle={styles.content}
        >
          <View style={styles.innerContent}>
            {loading && !moments?.length ? (
              <ActivityIndicator />
            ) : (
              <MomentList
                atemporal
                includeContext
                // chapterId={chapter?.id}
                // chapter={chapter}
                moments={moments}
                // values={chapter.values}
                // expanded={true}
                onUpdateMoments={(moments) => {
                  console.log("on update moments", moments);
                  this.setState({ moments });
                }}
                // onUpdateChapter={async (chapter) => {
                //   console.log("on update chapter!", chapter);
                //   await this.setState({ chapter, autoCreate: false });
                // }}
                // onAddChild={(value) => {
                //   this.setState({
                //     chapter: {
                //       ...chapter,
                //       moments: [...chapter.moments, { value_id: valud.id, value }],
                //       values: [...chapter.values, value],
                //     },
                //   });
                // }}
                // onRefreshChapter={this.fetchChapter}
              />
            )}
          </View>
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    // justifyContent: "center",
  },
  contentWrapper: {
    flex: 1,
    padding: 50,
  },
  content: {},
  innerContent: {
    flex: 1,
    alignSelf: "center",
    minWidth: 500,
    minHeight: 400,
    paddingBottom: HEIGHT / 3,
  },
});
